module.exports = __webpack_public_path__ + "static/Disclaimer-021f993f15341eccd3e0d18112d5b222.pdf";